// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dewott: PokeData = {
  "id": 502,
  "name": "dewott",
  "height": 8,
  "weight": 245,
  "base_experience": 145,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "tail-whip",
    "water-gun",
    "hydro-pump",
    "focus-energy",
    "slash",
    "fury-cutter",
    "encore",
    "revenge",
    "aerial-ace",
    "water-sport",
    "water-pulse",
    "aqua-tail",
    "aqua-jet",
    "soak",
    "retaliate",
    "razor-shell"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "aerial-ace",
    "aqua-tail",
    "aqua-jet",
    "whirlpool",
    "bubble",
    "liquidation",
    "brine",
    "rain-dance",
    "water-spout",
    "bubble-beam",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 258,
    "item": null,
    "species": [
      {
        "name": "oshawott",
        "order": 502,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dewott",
        "order": 503,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 501,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "samurott",
        "order": 504,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 502,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 60,
    "ability_power": 83
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
